define('modules/editor/models/property_groups/form_submit_format',['require','exports','module','./base','lib/util'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "form:submitFormat",
    properties: ["text", "fontSize", "width", "height", "fontWeight", "fontFamily", "align"],
    generateStyles: function($el, id){
      return [
        {
          selector: "#" + id + " .js-submit",
          rules: {
            "font-family": this.get("fontFamily"),
            "font-size": this.get("fontSize") + "px",
            "font-weight": this.get("fontWeight"),
            "height": this.get("height") + "px",
            "width": this.get("width") + "px",
            "line-height": this.get("height") + "px"
          }
        },
        {
          selector: "#" + id + " .js-submit-wrapper",
          rules: {
            "width": "100%",
            "text-align": this.get("align") || "left"
          }
        }
      ];
    },

    applyStyles: function($el){
      var btn = $el.find(".js-submit");
      if(btn.is("input")){
        btn.val(this.get("text"));
      }
      else {
        btn.html(this.get("text"));
      }

      if(this.get("align") === "free"){
        $el.find(".js-submit-wrapper").hide();
      }

      // var btn = $el.find(".js-submit"),
      //     wrapper = $el.find(".js-submit-wrapper"),
      //     align = this.get("align");
      // _.each(_.without(this.properties, "align"), function(prop){
      //   var value = this.get(prop);
      //   if (_.contains(["fontSize", "width", "height"], prop)) {
      //     value += "px";
      //   }
      //   if (prop !== "text") {
      //     btn.css(prop, value);
      //   } else {
      //     //set the text
      //     btn[btn.is("input")? "val" : "html"](value);
      //   }
      // }, this);
      // // align
      // if (_.contains(["left", "right"], align)) {
      //   wrapper.css("text-align", this.get("align") || "left");
      // } else if (align === "center") {
      //   btn.addClass("input-align");
      // } else {
      //   wrapper.hide();
      // }
    },

    validators: {
      text: function(attrs){
        return attrs.text.trim() !== "";
      },
      fontSize: function(attrs){
        var value = parseInt(attrs.fontSize);
        return this.isInteger(attrs.fontSize) && this.isNumber(value) && this.isInRange(value, 10, 60);
      },
      width: function(attrs){
        var value = parseInt(attrs.width);
        return this.isInteger(attrs.width) && this.isNumber(value) && this.isInRange(value, 10, 1200);
      },
      height: function(attrs){
        var value = parseInt(attrs.height);
        return this.isInteger(attrs.height) && this.isNumber(value) && this.isInRange(value, 10, 200);
      }
    }
  });
});

